import { render } from "./ProductCenter.vue?vue&type=template&id=37dd7260&scoped=true&ts=true"
import script from "./ProductCenter.vue?vue&type=script&lang=ts"
export * from "./ProductCenter.vue?vue&type=script&lang=ts"

import "./ProductCenter.vue?vue&type=style&index=0&id=37dd7260&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dd7260"]])

export default __exports__